<template>
  <gc-wc-funds :api-key="apiKey"
               description="Vetted funds addressing immediate and long-term needs in the U.S. and beyond."
               :exclude-categories="excludeCategories"
               :exclude-tags="excludeTags"
               :exclude-terms="excludeTerms"
               :include-categories="includeCategories"
               :include-tags="tags"
               :include-terms="includeTerms"
               :max-width="maxWidth"
               :per-page="perPage"
               :render-list-as="renderListAs"
               :title="title"
               :width="width"
               :dev-api-host="devApiHost"
               :dev-theme="devTheme"
               :dev-gtm-id="devGtmId">
    </gc-wc-funds>
</template>

<script>
import GcWcFunds from './GcWcFunds';

export default {
  components: {
    GcWcFunds,
  },
  props: {
    apiKey: {
      type: String,
      default: undefined,
    },
    excludeCategories: {
      type: String,
      default: null,
    },
    excludeTags: {
      type: String,
      default: null,
    },
    excludeTerms: {
      type: String,
      default: null,
    },
    includeCategories: {
      type: String,
      default: null,
    },
    includeTags: {
      type: String,
      default: null,
    },
    includeTerms: {
      type: String,
      default: null,
    },
    maxWidth: {
      type: String,
      default: undefined,
    },
    perPage: {
      type: [Number, String],
      default: undefined,
    },
    renderListAs: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: 'COVID-19 Funds',
    },
    width: {
      type: String,
      default: undefined,
    },
    devApiHost: {
      type: String,
      default: undefined,
    },
    devGtmId: {
      type: String,
      default: undefined,
    },
    devTheme: {
      type: String,
      default: undefined,
    },
  },
  data() {
    let tags = 'coronavirus';
    if (this.includeTags) {
      tags += `,${this.includeTags}`;
    }
    return {
      tags,
    };
  },
}
</script>
